import { __ } from '@wordpress/i18n';

/**
 * Legend component.
 */
export default function Legend() {
	return (
		<div className="tcc-map__legend">
			<h2 className="caption-text">{ __( 'Program Key', 'tcc-map' ) }</h2>
			<dl className="tcc-map__legend-list">
				<dt className="swatch light-green">
					<span className="screen-reader-text">{ __( 'Light green', 'tcc-map' ) }</span>
				</dt>
				<dd className="swatch-label">{ __( 'Health Program', 'tcc-map' ) }</dd>
				<dt className="swatch medium-green">
					<span className="screen-reader-text">{ __( 'Medium green', 'tcc-map' ) }</span>
				</dt>
				<dd className="swatch-swatch-label">{ __( 'Peace Program', 'tcc-map' ) }</dd>
				<dt className="swatch dark-green">
					<span className="screen-reader-text">{ __( 'Dark green', 'tcc-map' ) }</span>
				</dt>
				<dd className="swatch-label">{ __( 'Health and Peace Programs', 'tcc-map' ) }</dd>
			</dl>
		</div>
	);
}
